/**
 * 付费ODM落地页 - 数据获取
 * 纯展示页面，无需调用后端API，仅返回SEO信息和CDN配置
 *
 * 【注意】cdnHost 获取链路说明：
 * - SSR 模式：Egg.js SSR 框架直传 Koa ctx，通过 ctx.app.config.view.variable.CDN_HOST 获取
 *   （config.default.js 设为 test ossHost，config.prod.js 根据 NODE_ENV 覆盖为对应环境 ossHost）
 * - CSR 统一上下文模式：ssrDataLoader 包装后 ctx.ctx 为原始 Koa ctx（服务端）或 null（浏览器端）
 * - 浏览器端 fallback：layout/index.jsx 在 <script> 中注入了全局 const CDN_HOST = '${CDN_HOST}'
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @param {Function} request - 统一请求函数（本页面未使用）
 * @returns {Object} 页面初始化数据，包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  // 获取 Egg.js 原始上下文：SSR 框架直传原始 ctx（ctx.app 存在）或统一上下文包装（ctx.ctx）
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  // CSR fallback: 从 layout 模板注入的全局变量获取
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost: cdnHost,
    __seo: {
      title: 'CJdropshipping ODM Service | Custom Products, Branding & Packaging Solutions',
      keywords:
        'Turn your product ideas into branded products with CJdropshipping ODM service. From sourcing and packaging to private label and fulfillment, CJ helps you launch faster.',
      description:
        'CJdropshipping ODM service,custom products,ODM service,branding solutions,private label products,',
    },
  };
}

module.exports = fetchData;
